<style lang="stylus"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)"></MenuList>
</template>

<script lang="ts">
    declare var EDDocument: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AlignMenus extends Vue {
        isZhBuild = appConfig.language === "zh";

        get menuList() {
            let list = [
                { key: "starter", show: !this.isFocusMode },
                { key: "video1", isRender: this.internal && !this.isWorkwx },
                // { key: "usertask", isRender: this.internal && this.onUserTask && !this.isPrivate },
                // { key: "lineStyle" },
                // { key: "selAll" },
                // { key: "defaultSet" },
                // { key: "floatBtn" },
                // { key: "collectSymbol" },
                // { key: "publishTemp" },
                // { slot: "videoModal" },
            ];
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(Object.assign({}, item, { label: item.key == "usertask" ? "新手任务" : this.$t(item.key) }));
            });
            return { list: resultList };
        }
        handleClicks(...args) {
            let key = args[0];
            let clickEvents = new Map([
                [
                    "starter",
                    () => {
                        this.guideClick("starter", 0);
                    },
                ], // 原代码中没有写第二个参数
                [
                    "video1",
                    () => {
                        this.clickHelpMenu();
                    },
                ],
                // [ "usertask", () => { this.clickUserTask() } ],
                // [ "lineStyle", () => { this.guideClick("lineStyle", 0) } ],
                // [ "selAll", () => { this.guideClick("selAll", 1) } ],
                // [ "defaultSet", () => { this.guideClick("defaultSet", 2) } ],
                // [ "floatBtn", () => { this.guideClick("floatBtn", 3) } ],
                // [ "collectSymbol", () => { this.guideClick("collectSymbol") } ],
                // [ "publishTemp", () => { this.guideClick("publishTemp", 4) } ]
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        get isFocusMode() {
            return this.$store.state.ui.isFocusMode;
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        guideClick(type, idx) {
            if (type === "starter") {
                this.$bus.$emit("showShepherd");
                this.closeDrop();
                return;
                // this.$bus.$emit("starterGuide");
                // this.$track("menu", "help", "starterGuide");
            } else {
                this.$store.commit("setStatus", {
                    type: "guideActiveIndex",
                    data: idx,
                });
                this.$store.commit("setDialogState", {
                    type: "dialogType",
                    data: "GuideModal",
                });
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: true,
                });
                this.$track("Operation guide", "clickoperationguide", type);
            }
            this.closeDrop();
        }
        clickHelpMenu() {
            this.$bus.$emit("showVideo");
            this.closeDrop();
        }
        clickUserTask() {
            this.$bus.$emit("useUserTask");
            this.closeDrop();
        }
        get onUserTask() {
            return this.$store.state.publicStore.onUserTask;
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "starter": "新手向导",
    "video1": "入门视频",
    "lineStyle": "线条样式",
    "selAll": "选择所有",
    "defaultSet": "默认设置",
    "floatBtn": "浮动按钮",
    "collectSymbol": "收藏符号",
    "publishTemp": "发布模板"
  },
  "en": {
    "starter": "Get Started",
    "video1": "Getting Started Video",
    "lineStyle": "Line Style",
    "selAll": "Select All",
    "defaultSet": "Default Setting",
    "floatBtn": "Float Button",
    "collectSymbol": "Collect Symbol",
    "publishTemp": "Publish Template"
  },
  "fr": {
    "starter": "Guide novice",
    "video1": "Vidéo de démarrage",
    "lineStyle": "Style de ligne",
    "selAll": "Tout sélectionner",
    "defaultSet": "Paramètres par défaut",
    "floatBtn": "Bouton flottant",
    "collectSymbol": "Symbole de collection",
    "publishTemp": "Publier le modèle"
  },
  "de": {
    "starter": "Anfängerführung",
    "video1": "Einführungsvideo",
    "lineStyle": "Linienstil",
    "selAll": "Alles wählen",
    "defaultSet": "Voreinstellung",
    "floatBtn": "Float-Taste",
    "collectSymbol": "Symbole speichern",
    "publishTemp": "Vorlage veröffentlichen"
  },
  "jp": {
    "starter": "スタートガイド",
    "video1": "スタートガイド",
    "lineStyle": "線のスタイル",
    "selAll": "すべて選択",
    "defaultSet": "初期設定",
    "floatBtn": "フローティングボタン",
    "collectSymbol": "お気に入りの記号",
    "publishTemp": "テンプレートを公開する"
  },
  "es": {
    "starter": "Guía del novato",
    "video1": "Video de introducción",
    "lineStyle": "Estilo de línea",
    "selAll": "Seleccionar todo",
    "defaultSet": "Configuración predeterminada",
    "floatBtn": "Botón flotante",
    "collectSymbol": "coleccionar símbolo",
    "publishTemp": "Publicar plantilla"
  },
  "pt": {
    "starter": "Guia para Principiantes",
    "video1": "Vídeo de Introdução",
    "lineStyle": "Estilo de Linha",
    "selAll": "Selecionar tudo",
    "defaultSet": "Configuração Padrão",
    "floatBtn": "Botão Flutuante",
    "collectSymbol": "Coletar Símbolo",
    "publishTemp": "Publicar Modelo"
  },
  "it": {
    "starter": "Guida per principianti",
    "video1": "Video per iniziare",
    "lineStyle": "Stile della linea",
    "selAll": "Scegli tutto",
    "defaultSet": "Impostazioni predefinite",
    "floatBtn": "Pulsante fluttuante",
    "collectSymbol": "Salva simbolo",
    "publishTemp": "Pubblica il modello"
  },
  "tw": {
    "starter": "新手嚮導",
    "lineStyle": "線條樣式",
    "selAll": "選擇所有",
    "defaultSet": "默認設置",
    "floatBtn": "浮動按鈕",
    "collectSymbol": "收藏符號",
    "publishTemp": "發佈模板"
  }
}
</i18n>
